// native
import { Component, forwardRef } from '@angular/core';

// component
import { DataGridColumnComponent } from './data-grid-column.component';

/**
 * Command column (e.g. action buttons). Aliased to DataGridColumnComponent so a
 * single @ContentChildren(DataGridColumnComponent) query on the grid picks it up
 * in declaration order alongside regular columns.
 */
@Component({
    selector: 'app-data-grid-command-column',
    template: '',
    providers: [
        { provide: DataGridColumnComponent, useExisting: forwardRef(() => DataGridCommandColumnComponent) }
    ],
    standalone: false
})
export class DataGridCommandColumnComponent extends DataGridColumnComponent {
  override get isCommand(): boolean { return true; }
}
